const { render, useState } = wp.element;
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Cookies from "js-cookie";

//Action to save and fetch data
import {
    Savevotes,
    SendEmailVerify,
    frontimmutable,
    frontsingleimmute,
    verifyCaptcha,
    Cancel_votes,
} from "../../actions/front_actions";

//Import Designs
import { Button, FormControl, InputAdornment, TextField } from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import FavoriteIcon from "@mui/icons-material/Favorite";
import Loginpopup from "./Loginpopup.jsx";
import EmailGrab from "./EmailGrab.jsx";
import EmailVerify from "./EmailVerify.jsx";
import {
    Typography,
    Grid2,
    Link,
    Backdrop,
    CircularProgress,
    Dialog,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    DialogActions as MuiDialogActions,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import CancelButton from "./CancelButton.jsx";

import VoterDetailsPopup from "./VoterDetailsPopup.jsx";

import CheckIcon from "@mui/icons-material/Check";
import ContestantSocial from "./ContestantSocial.jsx";
import ReCAPTCHA from "react-google-recaptcha";
import { addHours } from "date-fns";
import dateFormat from "dateformat";

class VoteButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vote_font: "",
            vote_btn: "",
            show_login: false,
            show_emailgrab: false,
            show_voterdetails: false,
            email_address: "",
            show_emailverify: false,
            show_verifycode: 0,
            email_code: "",
            disabled: false,
            show_not_vote: 0,
            show_popup: 0,
            popup_title: null,
            popup_content: null,
            popup_extra: null,
            popbg_color: null,
            popbg_icon: null,
            show_index: null,
            vote_val: null,
            butn_mesg: null,
            show_recaptcha: 0,
            captcha_verfied: false,
            recaptcha: null,
            recaptcha_submit: null,
            vote_btn_loading: 0,
            HASH: Cookies.get("wpvc_voting_authorize"),
            buyvotes_split_votes: false,
            show_vote_count: 0,
            no_of_votes: 0,
        };
    }

    componentDidMount = () => {
        const button_status =
            typeof this.props.singlepost.vote_button_status !== "undefined"
                ? this.props.singlepost.vote_button_status
                : null;
        const butn_msg =
            typeof button_status === "object" && button_status != null
                ? button_status.update_vote_count.msg
                : true;
        let is_current_user_voted = this.props.singlepost.is_current_user_voted
            ?.length
            ? true
            : false;
        let butn_mesg = null;

        let buyvotes_split_votes = false;

        if (
            this.props.settings.wpvc_buyvotes_settings
                ?.ow_buyvotes_split_votes == "on"
        ) {
            buyvotes_split_votes =
                this.props.allcontest == 1
                    ? this.props.singlepost.allcatoption
                          .wpvc_category_buyvotes_settings == "on"
                    : this.props.short.allcatoption
                          .wpvc_category_buyvotes_settings == "on";
        }

        this.setState({ buyvotes_split_votes: buyvotes_split_votes });

        if (
            butn_msg == true ||
            (buyvotes_split_votes && this.props.buy_votes_count > 0)
        ) {
            this.setState({
                vote_font: this.props.settings.color.votes_button_font_color,
                vote_btn: this.props.settings.color.votes_button_bgcolor,
                butn_mesg: is_current_user_voted ? "voteagain" : butn_msg,
            });
            butn_mesg = is_current_user_voted ? "voteagain" : butn_msg;
        } else {
            this.setState({
                vote_font:
                    this.props.settings.color.votes_button_font_color_hover,
                vote_btn: this.props.settings.color.votes_button_bgcolor_hover,
                butn_mesg: !is_current_user_voted ? "voterestricted" : "voted",
            });
            butn_mesg = !is_current_user_voted ? "voterestricted" : "voted";
        }

        if (this.props.butn_msg != null) {
            this.setState({ butn_mesg: this.props.butn_msg });
        }

        if (this.props.setButtonText) {
            this.props.setButtonText(butn_mesg, this.props.indexpost);
        }

        if (buyvotes_split_votes && this.props.buy_votes_count > 0) {
            return;
        }

        if (
            this.props.settings.contest.vote_own_entry == "off" &&
            this.props.short.user_logged &&
            this.props.singlepost.author == this.props.short.user_id_profile
        ) {
            this.setState({
                butn_mesg: "voterestricted",
                vote_font:
                    this.props.settings.color.votes_button_font_color_hover,
                vote_btn: this.props.settings.color.votes_button_bgcolor_hover,
            });
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps == null) {
            return;
        }

        if (this.props.indexpost == "null" && this.props.butn_msg == null) {
            return;
        }

        if (
            this.props.setButtonText &&
            prevProps.butn_msg != this.state.butn_mesg
        ) {
            this.props.setButtonText(
                this.state.butn_mesg,
                this.props.indexpost
            );
            return;
        }
    }

    handlemodalclose = (event) => {
        this.setState({
            show_not_vote: 0,
            show_popup: 0,
            popup_title: null,
            popup_content: null,
            popbg_color: null,
            popbg_icon: null,
            show_index: null,
            vote_val: null,
        });
    };

    handlevotesmodalclose = (event) => {
        this.setState({
            show_vote_count: 0,
            no_of_votes: 0,
        });
    };

    handleEmailverify = () => {
        this.props
            .SendEmailVerify(this.props.SITE_URL, this.state.email_address)
            .then((val) => {
                this.setState({
                    disabled: true,
                    show_verifycode: 1,
                    email_code: val.code / 999,
                });
            });
    };

    get_cookieName = (votesetting, pid, termid) => {
        let cookie_name = "";
        const { frequency, vote_votingtype } = votesetting;

        //No Limit
        if (frequency == 0 && vote_votingtype == 0) {
            cookie_name = "wpvc_" + termid + "_frequency_" + frequency;
        }
        if (frequency == 0 && vote_votingtype == 1) {
            cookie_name =
                "wpvc_" + termid + "_frequency_" + frequency + "_" + pid;
        }
        if (frequency == 0 && vote_votingtype == 2) {
            cookie_name =
                "wpvc_" + termid + "_frequency_" + frequency + "_" + pid;
        }

        //Per Calender Day
        if (frequency == 1 && vote_votingtype == 0) {
            cookie_name = "wpvc_" + termid + "_frequency_" + frequency;
        }
        if (frequency == 1 && vote_votingtype == 1) {
            cookie_name =
                "wpvc_" + termid + "_frequency_" + frequency + "_" + pid;
        }
        if (frequency == 1 && vote_votingtype == 2) {
            cookie_name =
                "wpvc_" + termid + "_frequency_" + frequency + "_" + pid;
        }

        //Per Hours
        if (frequency == 2 && vote_votingtype == 0) {
            cookie_name = "wpvc_" + termid + "_frequency_" + frequency;
        }
        if (frequency == 2 && vote_votingtype == 1) {
            cookie_name =
                "wpvc_" + termid + "_frequency_" + frequency + "_" + pid;
        }
        if (frequency == 2 && vote_votingtype == 2) {
            cookie_name =
                "wpvc_" + termid + "_frequency_" + frequency + "_" + pid;
        }

        //Per Category
        if (frequency == 11 && vote_votingtype == 0) {
            cookie_name = "wpvc_" + termid + "_frequency_" + frequency;
        }
        if (frequency == 11 && vote_votingtype == 1) {
            cookie_name =
                "wpvc_" + termid + "_frequency_" + frequency + "_" + pid;
        }
        if (frequency == 11 && vote_votingtype == 2) {
            cookie_name =
                "wpvc_" + termid + "_frequency_" + frequency + "_" + pid;
        }

        return cookie_name;
    };

    handlevote = (
        post_id,
        term_id,
        vote_settings,
        post_index,
        cancel = null,
        butn_msg = true
    ) => {
        if (
            cancel !== 1 &&
            this.state.buyvotes_split_votes &&
            this.props.buy_votes_count > 0 &&
            this.state.no_of_votes <= 0
        ) {
            this.setState({ show_vote_count: 1 });
            return;
        }

        this.setState({
            vote_btn_loading: 1,
            vote_val: null,
            show_vote_count: 0,
        });
        const { user_logged } = this.props.short;
        const { vote_enable_recaptcha_voting, vote_recapatcha_key } =
            this.props.settings.common;
        const { vote_tracking_method, vote_own_entry } = vote_settings;
        let contest_settings = {};

        //Add the User ID from JS
        contest_settings.user_logged = user_logged;
        contest_settings.user_id_profile = this.props.short.user_id_profile;

        contest_settings = Object.assign(contest_settings, vote_settings);

        if (cancel === 1) {
            this.handleCancelVotes(
                post_id,
                term_id,
                contest_settings,
                post_index
            );
            return;
        }

        if (
            this.state.no_of_votes <= 0 &&
            (this.props.singlepost.vote_button_status !== true ||
                (butn_msg != true && butn_msg != "voteagain"))
        ) {
            let pop_title =
                this.props.singlepost.vote_button_status.update_vote_count
                    ?.poptitle != null
                    ? this.props.singlepost.vote_button_status.update_vote_count
                          .poptitle
                    : "voted_already";
            let pop_content =
                this.props.singlepost.vote_button_status.update_vote_count
                    ?.popcontent != null
                    ? this.props.singlepost.vote_button_status.update_vote_count
                          .popcontent
                    : "already_content";

            if (
                vote_own_entry == "off" &&
                user_logged &&
                this.props.singlepost.author == this.props.short.user_id_profile
            ) {
                pop_title = "voterestricted";
                pop_content = "cannot_vote_own_post";
            }

            this.setState({
                show_popup: 1,
                popup_title: pop_title,
                popup_content: pop_content,
                popbg_color: "#e67e22",
                popbg_icon: "already",
                show_index: post_index,
                showhtml: false,
            });
            this.setState({ vote_btn_loading: 0 });
            return;
        }

        const {
            vote_grab_email_address,
            vote_grab_name,
            vote_grab_country,
            vote_grab_zipcode,
            vote_grab_consent,
            onlyloggedinuser,
        } = vote_settings;

        //IP Trace or Cookie Trace and Email Grab
        if (
            (vote_tracking_method == "cookie_traced" ||
                vote_tracking_method == "ip_traced") &&
            user_logged === false &&
            vote_grab_email_address === "on" &&
            onlyloggedinuser === "off"
        ) {
            this.setState({ show_emailgrab: true });
        } else if (
            vote_tracking_method == "email_verify" &&
            user_logged === false
        ) {
            this.setState({ show_emailverify: true });
        } else if (
            vote_tracking_method == "ip_email" &&
            user_logged === false
        ) {
            this.setState({ show_emailverify: true });
        } else if (
            this.state.show_emailgrab == false &&
            this.state.show_emailverify == 0 &&
            (vote_grab_name == "on" ||
                vote_grab_country == "on" ||
                vote_grab_zipcode == "on" ||
                vote_grab_consent == "on")
        ) {
            this.setState({ show_voterdetails: true });
        } else if (
            vote_enable_recaptcha_voting == "on" &&
            this.state.captcha_verfied == false &&
            vote_recapatcha_key != ""
        ) {
            this.setState({
                show_recaptcha: 1,
                recaptcha_submit: {
                    post_id: post_id,
                    term_id: term_id,
                    contest_settings: contest_settings,
                    post_index: post_index,
                },
            });
        } else {
            this.handleSaveVotes(
                post_id,
                term_id,
                contest_settings,
                post_index
            );
        }
    };

    handleSaveVotes = (
        post_id,
        term_id,
        vote_settings,
        post_index,
        email = null
    ) => {
        const voter_details = {
            voter_name: this.state.voter_name,
            voter_country: this.state.voter_country,
            voter_zipcode: this.state.voter_zipcode,
        };
        let newsletter = this.state.vote_newsletter === true ? 1 : 0;
        this.props
            .Savevotes(
                this.props.SITE_URL,
                post_id,
                term_id,
                vote_settings,
                post_index,
                email,
                voter_details,
                this.state.no_of_votes,
                newsletter
            )
            .then((val) => {
                console.log(val);
                this.setState({
                    vote_val: val,
                    show_emailgrab: false,
                    email_address: "",
                    show_voterdetails: false,
                    show_verifycode: 0,
                    email_code: "",
                    show_emailverify: false,
                    disabled: false,
                    captcha_verfied: false,
                    recaptcha: null,
                    vote_btn_loading: 0,
                    voter_name: "",
                    voter_country: "",
                    voter_zipcode: "",
                    no_of_votes: 0,
                    show_vote_count: 0,
                });
                this.onvotedfunction(this.props.indexpost, val);
            });
    };

    handleCancelVotes = (
        post_id,
        term_id,
        vote_settings,
        post_index,
        email = null
    ) => {
        this.props
            .Cancel_votes(
                this.props.SITE_URL,
                post_id,
                term_id,
                vote_settings,
                post_index,
                email
            )
            .then((val) => {
                this.setState({
                    vote_val: val,
                    show_emailgrab: false,
                    email_address: "",
                    show_voterdetails: false,
                    show_verifycode: 0,
                    email_code: "",
                    show_emailverify: false,
                    disabled: false,
                    captcha_verfied: false,
                    recaptcha: null,
                    vote_btn_loading: 0,
                    voter_name: "",
                    voter_country: "",
                    voter_zipcode: "",
                });
                this.onvotedfunction(this.props.indexpost, val);
            });
    };

    handlelogin = () => {
        this.setState({ show_login: true });
    };

    handleClose = (event) => {
        this.setState({ show_login: false });
    };

    email_handleClose = (event) => {
        this.setState({
            show_emailgrab: false,
            show_voterdetails: false,
            email_address: "",
            show_verifycode: 0,
            email_code: "",
            show_emailverify: false,
            disabled: false,
            recaptcha: null,
            vote_btn_loading: 0,
        });
    };

    handleEmailValueChange = (event) => {
        this.setState({ email_address: event.target.value });
    };

    handleVoterDetails = (event) => {
        let value =
            event.target.type == "checkbox"
                ? event.target.checked
                : event.target.value;
        this.setState({ [event.target.name]: value });
    };

    handleVoteCount = (event) => {
        let value =
            parseInt(event.target.value) > parseInt(this.props.buy_votes_count)
                ? this.props.buy_votes_count
                : event.target.value;
        this.setState({ no_of_votes: value < 1 ? 0 : value });
    };

    handleCaptchaValueChange = (event) => {
        this.setState({ recaptcha: event });
    };

    toggleHovertwo = (value, val, name, butn_msg) => () => {
        if (butn_msg == true)
            this.setState({ vote_font: value, vote_btn: val });
    };

    toggleleavetwo = (value, val, name, butn_msg) => () => {
        if (butn_msg == true)
            this.setState({ vote_font: value, vote_btn: val });
    };

    calculateVoteTimeLeft(start_time, pause_voting_hours = 0) {
        let current_date = this.props.currentdate;
        if (!current_date) {
            current_date = new Date();
        }
        if (start_time != null) {
            start_time = start_time.replace(/ /g, "T");
            // var dateFormat = require("dateformat");
            var start_Date = dateFormat(start_time);
            let difference =
                addHours(new Date(start_Date), pause_voting_hours) -
                current_date;
            return difference;
        } else {
            return -1;
        }
    }

    isContains(json, key, value) {
        let contains = false;
        json.filter(function (object) {
            if (object[key] == value) {
                contains = true;
            }
        });
        return contains;
    }

    onvotedfunction = (postind, update_btn) => {
        // let update_btn = this.state.vote_val;
        let popup_check = this.state.show_popup;
        if (update_btn != null && popup_check == 0) {
            let post_index = update_btn.update_vote_count.post_index;
            if (postind == post_index) {
                let message = update_btn.update_vote_count.msg;

                let pop_title =
                    update_btn.update_vote_count.poptitle != null
                        ? update_btn.update_vote_count.poptitle
                        : "voted_already";
                let pop_content =
                    update_btn.update_vote_count.popcontent != null
                        ? update_btn.update_vote_count.popcontent
                        : "already_content";

                if (
                    typeof update_btn.update_vote_count.voting_count !==
                    "undefined"
                ) {
                    let voting_count =
                        update_btn.update_vote_count.voting_count;
                    const posts =
                        typeof this.props.post.posts === "undefined"
                            ? "post_single"
                            : "posts";
                    if (post_index == "null") {
                        this.props.frontsingleimmute(
                            posts,
                            "votes_count",
                            voting_count
                        );
                        this.props.frontsingleimmute(
                            posts,
                            "vote_button_status",
                            update_btn.update_vote_count.is_votable
                        );
                    } else {
                        this.props.frontimmutable(
                            posts,
                            post_index,
                            "votes_count",
                            voting_count
                        );
                        this.props.frontimmutable(
                            posts,
                            post_index,
                            "vote_button_status",
                            update_btn.update_vote_count.is_votable
                        );
                    }
                }

                if (update_btn.is_cancel_vote == true) {
                    this.setState({
                        show_popup: 1,
                        popup_title: "votes_cancelled",
                        popup_content: "votes_cancelled_content",
                        popbg_color: "#ff000c",
                        popbg_icon: "already",
                        show_index: post_index,
                        showhtml: false,
                    });
                } else {
                    if (message == "voted") {
                        this.setState({
                            show_popup: 1,
                            popup_title: "voted_sucess",
                            popup_content:
                                this.props.settings.contest.voted_message ||
                                "you_voted",
                            showhtml: this.props.settings.contest.voted_message
                                ? true
                                : false,
                            popbg_color: "#29b664",
                            popbg_icon: "sucess",
                            show_index: post_index,
                        });
                    }

                    if (message == "already") {
                        this.setState({
                            show_popup: 1,
                            popup_title: pop_title,
                            popup_content: pop_content,
                            popbg_color: "#e67e22",
                            popbg_icon: "already",
                            show_index: post_index,
                            showhtml: false,
                        });
                    }
                }
            }
        }
    };

    componentWillReceiveProps = (nextProps) => {
        const {
            votes_button_font_color_hover,
            votes_button_bgcolor_hover,
            votes_button_font_color,
            votes_button_bgcolor,
        } = this.props.settings.color;

        if (typeof nextProps.update_vote_count !== "undefined") {
            if (nextProps.voted_category_id != nextProps.singlepost.term_id) {
                return;
            }
            const {
                vote_tracking_method,
                vote_frequency_count,
                vote_votingtype,
                frequency,
            } = this.props.settings.contest;

            let voting_freq =
                typeof nextProps.update_vote_count.cat_select !== "undefined"
                    ? nextProps.update_vote_count.cat_select
                    : "";
            let response_val =
                typeof nextProps.update_vote_count.resp_val !== "undefined"
                    ? nextProps.update_vote_count.resp_val
                    : "";
            let post_index = nextProps.update_vote_count.post_index;
            let single_index = nextProps.indexpost;

            let post_id_val =
                typeof nextProps.singlepost !== "undefined"
                    ? nextProps.singlepost.id
                    : "";
            let is_votable =
                typeof nextProps.update_vote_count.is_votable !== "undefined"
                    ? nextProps.update_vote_count.is_votable
                    : "";
            let is_current_user_voted =
                typeof nextProps.update_vote_count?.is_votable
                    ?.update_vote_count !== "undefined"
                    ? nextProps.update_vote_count.is_votable.update_vote_count
                          ?.is_current_user_voted
                    : false;

            let user_vote_count =
                typeof nextProps.update_vote_count !== "undefined"
                    ? nextProps.update_vote_count?.user_count
                    : 0;
            let is_cancel_vote =
                typeof nextProps.is_cancel_vote !== "undefined"
                    ? nextProps.is_cancel_vote
                    : false;

            if (
                nextProps.bonus_vote_count <= 0 &&
                (!this.state.buyvotes_split_votes ||
                    (this.state.buyvotes_split_votes &&
                        nextProps.buy_votes_count <= 0))
            ) {
                //Based on frequency set state
                if (voting_freq == "no_limit") {
                    if (response_val == "single") {
                        if (post_index == single_index) {
                            this.setState({
                                butn_mesg:
                                    user_vote_count <= 0 ? true : "voteagain",
                                vote_btn: votes_button_bgcolor,
                                vote_font: votes_button_font_color,
                            });
                        } else {
                            this.setState({
                                butn_mesg: user_vote_count <= 0 ? true : false,
                                vote_btn:
                                    user_vote_count <= 0
                                        ? votes_button_bgcolor
                                        : votes_button_bgcolor_hover,
                                vote_font:
                                    user_vote_count <= 0
                                        ? votes_button_font_color
                                        : votes_button_font_color_hover,
                            });
                        }
                    }
                }
                if (
                    voting_freq == "per_calendar" ||
                    voting_freq == "per_hour" ||
                    voting_freq == "per_category"
                ) {
                    if (response_val == "single") {
                        if (vote_tracking_method == "cookie_traced") {
                            // Cookie Tracing
                            if (
                                vote_frequency_count == 1 &&
                                vote_votingtype == 0
                            ) {
                                // Single & Count = 1
                                if (
                                    is_cancel_vote == true &&
                                    nextProps.update_vote_count?.user_count <= 0
                                ) {
                                    this.setState({
                                        butn_mesg: true,
                                        vote_btn: votes_button_bgcolor,
                                        vote_font: votes_button_font_color,
                                    });
                                } else {
                                    if (
                                        is_votable == true &&
                                        post_index == single_index
                                    ) {
                                        this.setState({
                                            butn_mesg: "voted",
                                            vote_btn:
                                                votes_button_bgcolor_hover,
                                            vote_font:
                                                votes_button_font_color_hover,
                                        });
                                    } else {
                                        this.setState({
                                            butn_mesg: false,
                                            vote_btn:
                                                votes_button_bgcolor_hover,
                                            vote_font:
                                                votes_button_font_color_hover,
                                        });
                                    }
                                }
                            } else {
                                // Single & Count > 1
                                let current_cookie = this.get_cookieName(
                                    this.props.settings.contest,
                                    post_id_val,
                                    this.props.short.id
                                );
                                let current_cookie_count =
                                    `${current_cookie}` + "_count";
                                if (
                                    is_cancel_vote == true &&
                                    nextProps.update_vote_count?.user_count <= 0
                                ) {
                                    this.setState({
                                        butn_mesg: true,
                                        vote_btn: votes_button_bgcolor,
                                        vote_font: votes_button_font_color,
                                    });
                                } else {
                                    if (
                                        Cookies.get(
                                            `${current_cookie_count}`
                                        ) == vote_frequency_count
                                    ) {
                                        if (
                                            is_votable == true &&
                                            post_index == single_index
                                        ) {
                                            this.setState({
                                                butn_mesg: "voted",
                                                vote_btn:
                                                    votes_button_bgcolor_hover,
                                                vote_font:
                                                    votes_button_font_color_hover,
                                            });
                                        } else {
                                            this.setState({
                                                butn_mesg: false,
                                                vote_btn:
                                                    votes_button_bgcolor_hover,
                                                vote_font:
                                                    votes_button_font_color_hover,
                                            });
                                        }
                                    } else if (
                                        Cookies.get(`${current_cookie}`) ==
                                        post_id_val
                                    ) {
                                        this.setState({
                                            butn_mesg: "voteagain",
                                            vote_btn: votes_button_bgcolor,
                                            vote_font: votes_button_font_color,
                                        });
                                    } else {
                                        this.setState({
                                            butn_mesg: false,
                                            vote_btn:
                                                votes_button_bgcolor_hover,
                                            vote_font:
                                                votes_button_font_color_hover,
                                        });
                                    }
                                }
                            }
                        } else {
                            if (
                                is_votable == true &&
                                post_index == single_index
                            ) {
                                if (
                                    is_cancel_vote == true &&
                                    nextProps.update_vote_count?.user_count <= 0
                                ) {
                                    this.setState({
                                        butn_mesg: true,
                                        vote_btn: votes_button_bgcolor,
                                        vote_font: votes_button_font_color,
                                    });
                                } else {
                                    this.setState({
                                        butn_mesg: "voteagain",
                                        vote_btn: votes_button_bgcolor,
                                        vote_font: votes_button_font_color,
                                    });
                                }
                                // if (vote_tracking_method == 'email_verify' || vote_tracking_method == 'ip_email') {
                                //     this.setState({
                                //         butn_mesg: 'voted',
                                //         vote_btn: votes_button_bgcolor_hover,
                                //         vote_font: votes_button_font_color_hover
                                //     });
                                // }
                            } else {
                                let check_current_user_voted =
                                    is_current_user_voted !== undefined &&
                                    is_current_user_voted != 0
                                        ? this.isContains(
                                              is_current_user_voted,
                                              "post_id",
                                              post_id_val
                                          )
                                        : false;
                                if (check_current_user_voted == true) {
                                    this.setState({
                                        butn_mesg: "voted",
                                        vote_btn: votes_button_bgcolor_hover,
                                        vote_font:
                                            votes_button_font_color_hover,
                                    });
                                } else {
                                    if (
                                        is_cancel_vote == true &&
                                        !nextProps.update_vote_count?.user_count
                                    ) {
                                        this.setState({
                                            butn_mesg: true,
                                            vote_btn: votes_button_bgcolor,
                                            vote_font: votes_button_font_color,
                                        });
                                    } else {
                                        this.setState({
                                            butn_mesg: false,
                                            vote_btn:
                                                votes_button_bgcolor_hover,
                                            vote_font:
                                                votes_button_font_color_hover,
                                        });
                                    }
                                }
                            }
                        }
                    } else {
                        let post_id_arr =
                            nextProps.update_vote_count.voted_post_ids;
                        let find_post_id = this.isContains(
                            post_id_arr,
                            "post_id",
                            post_id_val
                        );
                        let check_current_user_voted =
                            is_current_user_voted !== undefined &&
                            is_current_user_voted != 0
                                ? this.isContains(
                                      is_current_user_voted,
                                      "post_id",
                                      post_id_val
                                  )
                                : false;
                        if (
                            typeof is_votable.update_vote_count !==
                                "undefined" &&
                            vote_tracking_method !== "cookie_traced"
                        ) {
                            let post_count =
                                typeof is_votable.update_vote_count
                                    .post_count !== "undefined"
                                    ? is_votable.update_vote_count.post_count
                                    : "";
                            let freq_count =
                                typeof is_votable.update_vote_count
                                    .freq_count !== "undefined"
                                    ? is_votable.update_vote_count.freq_count
                                    : "";
                            if (freq_count == 1) {
                                if (check_current_user_voted == true) {
                                    this.setState({
                                        butn_mesg: "voted",
                                        vote_btn: votes_button_bgcolor_hover,
                                        vote_font:
                                            votes_button_font_color_hover,
                                    });
                                } else {
                                    this.setState({
                                        butn_mesg: true,
                                        vote_btn: votes_button_bgcolor,
                                        vote_font: votes_button_font_color,
                                    });
                                }
                            } else {
                                if (is_votable == true) {
                                    this.setState({
                                        butn_mesg: true,
                                        vote_btn: votes_button_bgcolor,
                                        vote_font: votes_button_font_color,
                                    });
                                } else if (check_current_user_voted == true) {
                                    this.setState({
                                        butn_mesg: "voted",
                                        vote_btn: votes_button_bgcolor_hover,
                                        vote_font:
                                            votes_button_font_color_hover,
                                    });
                                } else if (post_count >= freq_count) {
                                    this.setState({
                                        butn_mesg: false,
                                        vote_btn: votes_button_bgcolor_hover,
                                        vote_font:
                                            votes_button_font_color_hover,
                                    });
                                } else {
                                    this.setState({
                                        butn_mesg: true,
                                        vote_btn: votes_button_bgcolor,
                                        vote_font: votes_button_font_color,
                                    });
                                }
                            }
                        } else {
                            if (vote_tracking_method == "cookie_traced") {
                                // Cookie Tracing
                                if (vote_frequency_count == 1) {
                                    // Multiple & Count = 1
                                    let find_post_id = this.isContains(
                                        post_id_arr,
                                        "post_id",
                                        post_id_val
                                    );
                                    let current_cookie = this.get_cookieName(
                                        this.props.settings.contest,
                                        post_id_val,
                                        this.props.short.id
                                    );
                                    if (
                                        Cookies.get(`${current_cookie}`) ===
                                            undefined &&
                                        is_cancel_vote == true
                                    ) {
                                        this.setState({
                                            butn_mesg: true,
                                            vote_btn: votes_button_bgcolor,
                                            vote_font: votes_button_font_color,
                                        });
                                    } else {
                                        if (
                                            find_post_id == true &&
                                            Cookies.get(`${current_cookie}`)
                                        ) {
                                            this.setState({
                                                butn_mesg: "voted",
                                                vote_btn:
                                                    votes_button_bgcolor_hover,
                                                vote_font:
                                                    votes_button_font_color_hover,
                                            });
                                        }
                                    }
                                } else {
                                    let find_post_id = this.isContains(
                                        post_id_arr,
                                        "post_id",
                                        post_id_val
                                    );
                                    let current_cookie = this.get_cookieName(
                                        this.props.settings.contest,
                                        post_id_val,
                                        this.props.short.id
                                    );
                                    let current_cookie_count =
                                        "wpvc_" +
                                        this.props.short.id +
                                        "_frequency_" +
                                        frequency +
                                        "_counter";
                                    if (vote_votingtype == 1) {
                                        // Multiple Exclusive & Count  > 1
                                        if (
                                            Cookies.get(
                                                `${current_cookie_count}`
                                            ) == vote_frequency_count
                                        ) {
                                            if (
                                                find_post_id == true &&
                                                Cookies.get(`${current_cookie}`)
                                            ) {
                                                this.setState({
                                                    butn_mesg: "voted",
                                                    vote_btn:
                                                        votes_button_bgcolor_hover,
                                                    vote_font:
                                                        votes_button_font_color_hover,
                                                });
                                            } else {
                                                this.setState({
                                                    butn_mesg: false,
                                                    vote_btn:
                                                        votes_button_bgcolor_hover,
                                                    vote_font:
                                                        votes_button_font_color_hover,
                                                });
                                            }
                                        } else if (
                                            find_post_id == true &&
                                            Cookies.get(`${current_cookie}`)
                                        ) {
                                            this.setState({
                                                butn_mesg: "voted",
                                                vote_btn:
                                                    votes_button_bgcolor_hover,
                                                vote_font:
                                                    votes_button_font_color_hover,
                                            });
                                        } else {
                                            this.setState({
                                                butn_mesg: true,
                                                vote_btn: votes_button_bgcolor,
                                                vote_font:
                                                    votes_button_font_color,
                                            });
                                        }
                                    } else {
                                        // Multiple Split & Count  > 1
                                        if (
                                            find_post_id == true &&
                                            Cookies.get(`${current_cookie}`) &&
                                            Cookies.get(
                                                `${current_cookie_count}`
                                            ) < vote_frequency_count
                                        ) {
                                            this.setState({
                                                butn_mesg: "voteagain",
                                                vote_btn: votes_button_bgcolor,
                                                vote_font:
                                                    votes_button_font_color,
                                            });
                                        } else if (
                                            Cookies.get(
                                                `${current_cookie_count}`
                                            ) == vote_frequency_count
                                        ) {
                                            if (
                                                find_post_id == true &&
                                                Cookies.get(`${current_cookie}`)
                                            ) {
                                                this.setState({
                                                    butn_mesg: "voted",
                                                    vote_btn:
                                                        votes_button_bgcolor_hover,
                                                    vote_font:
                                                        votes_button_font_color_hover,
                                                });
                                            } else {
                                                this.setState({
                                                    butn_mesg: false,
                                                    vote_btn:
                                                        votes_button_bgcolor_hover,
                                                    vote_font:
                                                        votes_button_font_color_hover,
                                                });
                                            }
                                        } else if (
                                            find_post_id == true &&
                                            Cookies.get(
                                                `${current_cookie}` &&
                                                    Cookies.get(
                                                        `${current_cookie_count}`
                                                    ) == vote_frequency_count
                                            )
                                        ) {
                                            this.setState({
                                                butn_mesg: false,
                                                vote_btn:
                                                    votes_button_bgcolor_hover,
                                                vote_font:
                                                    votes_button_font_color_hover,
                                            });
                                        } else {
                                            this.setState({
                                                butn_mesg: true,
                                                vote_btn: votes_button_bgcolor,
                                                vote_font:
                                                    votes_button_font_color,
                                            });
                                        }
                                    }
                                }
                            } else {
                                if (is_votable == true) {
                                    if (
                                        is_cancel_vote == true &&
                                        user_vote_count <= 0
                                    ) {
                                        if (find_post_id === true) {
                                            this.setState({
                                                butn_mesg: "voted",
                                                vote_btn:
                                                    votes_button_bgcolor_hover,
                                                vote_font:
                                                    votes_button_font_color_hover,
                                            });
                                        } else {
                                            this.setState({
                                                butn_mesg: true,
                                                vote_btn: votes_button_bgcolor,
                                                vote_font:
                                                    votes_button_font_color,
                                            });
                                        }
                                    } else {
                                        if (
                                            user_vote_count > 0 &&
                                            find_post_id === true
                                        ) {
                                            if (vote_votingtype == 1) {
                                                this.setState({
                                                    butn_mesg: "voted",
                                                    vote_btn:
                                                        votes_button_bgcolor_hover,
                                                    vote_font:
                                                        votes_button_font_color_hover,
                                                });
                                            } else {
                                                this.setState({
                                                    butn_mesg: "voteagain",
                                                    vote_btn:
                                                        votes_button_bgcolor,
                                                    vote_font:
                                                        votes_button_font_color,
                                                });
                                            }
                                        } else {
                                            this.setState({
                                                butn_mesg: true,
                                                vote_btn: votes_button_bgcolor,
                                                vote_font:
                                                    votes_button_font_color,
                                            });
                                        }
                                    }
                                } else {
                                    this.setState({
                                        butn_mesg: false,
                                        vote_btn: votes_button_bgcolor_hover,
                                        vote_font:
                                            votes_button_font_color_hover,
                                    });
                                }
                            }
                        }
                    }
                }
            }
        }

        if (this.state.buyvotes_split_votes && nextProps.buy_votes_count > 0) {
            this.setState({
                butn_mesg: true,
                vote_font: votes_button_font_color,
                vote_btn: votes_button_bgcolor,
            });
            return;
        }

        const check_logged = nextProps.short.user_logged;
        if (
            this.props.settings.contest.vote_own_entry == "off" &&
            check_logged &&
            nextProps.singlepost.author == nextProps.short.user_id_profile
        ) {
            this.setState({
                butn_mesg: "voterestricted",
                vote_font: votes_button_font_color_hover,
                vote_btn: votes_button_bgcolor_hover,
            });
            return;
        }

        if (
            this.props.setButtonText &&
            nextProps.button_msg != this.props.button_msg
        ) {
            let is_current_user_voted = nextProps.singlepost
                .is_current_user_voted?.length
                ? true
                : false;
            if (nextProps.button_msg == true) {
                this.setState({
                    vote_font: votes_button_font_color,
                    vote_btn: votes_button_bgcolor,
                    butn_mesg: is_current_user_voted
                        ? "voteagain"
                        : nextProps.button_msg,
                });
            } else {
                this.setState({
                    vote_font: votes_button_font_color_hover,
                    vote_btn: votes_button_bgcolor_hover,
                    butn_mesg: !is_current_user_voted
                        ? "voterestricted"
                        : "voted",
                });
            }
        }
    };

    onCaptchaClick = (value) => {
        if (value) {
            this.props.verifyCaptcha(this.props.SITE_URL, value).then((val) => {
                this.setState({
                    captcha_verfied: val.verified,
                    show_recaptcha: val.verified ? 0 : 1,
                });
                if (val.verified) {
                    this.handleSaveVotes(
                        this.state.recaptcha_submit.post_id,
                        this.state.recaptcha_submit.term_id,
                        this.state.recaptcha_submit.contest_settings,
                        this.state.recaptcha_submit.post_index
                    );
                }
            });
        }
    };

    handleCaptchaClose = (event) => {
        this.setState({
            show_recaptcha: 0,
            vote_btn_loading: 0,
        });
    };

    render() {
        if (this.props.wait == 1) {
            return;
        }
        const { t } = this.props;

        const {
            votes_button_font_size,
            votes_button_font_color,
            votes_button_font_color_hover,
            votes_button_bgcolor,
            votes_button_bgcolor_hover,
        } = this.props.settings.color;
        const {
            facebook,
            threads,
            linkedin,
            pinterest,
            tumblr,
            reddit,
            twitter,
        } = this.props.settings.share;
        const posts =
            typeof this.props.post.posts === "undefined"
                ? this.props.post_single
                : this.props.post.posts;
        const post_index = this.props.indexpost;
        const allprops = this.props;
        const onlylogged = allprops.short.onlyloggedinuser;
        const check_logged = allprops.short.user_logged;
        const single_page =
            typeof this.props.single_page !== "undefined"
                ? this.props.single_page
                : null;
        let shortcode =
            typeof this.props.short !== "undefined"
                ? this.props.short.allcatoption
                : null;
        if (this.props.allcontest == 1) {
            const taxonomy = this.props.post.taxonomy.filter((taxonomy) => {
                return taxonomy.term_id === this.props.termid;
            });
            shortcode = taxonomy[0];
        }

        const { vote_recapatcha_key } = this.props.settings.common;
        const { vote_tracking_method } = this.props.settings.contest;

        //Button And popup text showup
        // this.onvotedfunction(this.props.indexpost);
        let butn_msg = this.state.butn_mesg;

        //Check voting button
        let time_to_vote = null;
        let timer = null;
        let pagin_val_prop = null;

        if (shortcode != null) {
            let get_view = this.props.view;
            pagin_val_prop =
                typeof allprops.post.pagin_val !== "undefined"
                    ? allprops.post.pagin_val
                    : null;
            if (get_view === "single") {
                pagin_val_prop = allprops.post_single.contestant_count;
            }

            if (pagin_val_prop != null) {
                let total_posts =
                    get_view === "single"
                        ? pagin_val_prop
                        : pagin_val_prop.total_posts;
                let tax_activationcount = shortcode.tax_activationcount || 0;

                if (
                    tax_activationcount !== 0 &&
                    parseInt(tax_activationcount) <= parseInt(total_posts)
                ) {
                    time_to_vote = null;
                } else if (
                    shortcode.votes_starttime != null &&
                    shortcode.votes_starttime != ""
                ) {
                    timer = this.calculateVoteTimeLeft(
                        shortcode.votes_starttime,
                        shortcode.pause_voting
                    );
                    if (timer > 0) {
                        time_to_vote = "not_started";
                    }
                }

                if (
                    shortcode.votes_expiration != null &&
                    shortcode.votes_expiration != ""
                ) {
                    timer = this.calculateVoteTimeLeft(
                        shortcode.votes_expiration
                    );
                    if (timer < 0) {
                        time_to_vote = "ended";
                    }
                }
            }
        }

        let default_size = "auto";
        let term_id = this.props.short.id;
        const allcontest = this.props.allcontest;
        if (allcontest == 1) {
            if (time_to_vote != null) {
                return "";
            }
            default_size = 4;
            term_id = this.props.termid;
        }

        //REnder Items
        if (posts) {
            return (
                <React.Fragment>
                    <Grid2
                        className={
                            single_page == null
                                ? "wpvc_vote_cast_btn"
                                : "wpvc_vote_cast_single_btn"
                        }
                        size={single_page != null ? 12 : default_size}
                    >
                        {single_page != null && time_to_vote == null && (
                            <Link
                                href={
                                    posts.previous_link != null
                                        ? posts.previous_link
                                        : undefined
                                }
                                className="wpvc_single_next_button"
                                style={{
                                    color: votes_button_font_color,
                                    background: votes_button_bgcolor,
                                    opacity:
                                        posts.previous_link != null ? 1 : 0.6,
                                }}
                                title={
                                    posts.previous_title != null
                                        ? posts.previous_title
                                        : ""
                                }
                            >
                                <NavigateBeforeIcon className="wpvc_prev_post" />
                            </Link>
                        )}

                        {
                            //For all contestant icon button
                            allcontest == 1 && (
                                <div>
                                    {(onlylogged == 0 ||
                                        check_logged == true) &&
                                        time_to_vote == null &&
                                        wp.hooks.applyFilters(
                                            "wpvc_buyvotes_btn",
                                            <IconButton
                                                color="primary"
                                                style={{
                                                    fontSize:
                                                        votes_button_font_size +
                                                        "px",
                                                    color: this.state.vote_font,
                                                    background:
                                                        this.state.vote_btn,
                                                }}
                                                onMouseOver={this.toggleHovertwo(
                                                    votes_button_font_color_hover,
                                                    votes_button_bgcolor_hover,
                                                    "vote_btn",
                                                    butn_msg
                                                )}
                                                onMouseLeave={this.toggleleavetwo(
                                                    votes_button_font_color,
                                                    votes_button_bgcolor,
                                                    "vote_btn",
                                                    butn_msg
                                                )}
                                                onClick={() =>
                                                    this.handlevote(
                                                        this.props.singlepost
                                                            .id,
                                                        term_id,
                                                        this.props.settings
                                                            .contest,
                                                        post_index,
                                                        null,
                                                        butn_msg
                                                    )
                                                }
                                            >
                                                <FavoriteIcon />
                                            </IconButton>,
                                            this.props,
                                            butn_msg,
                                            this.state.HASH
                                        )}
                                    {onlylogged == 1 &&
                                        check_logged == false &&
                                        time_to_vote == null &&
                                        wp.hooks.applyFilters(
                                            "wpvc_buyvotes_btn",
                                            <IconButton
                                                color="primary"
                                                style={{
                                                    fontSize:
                                                        votes_button_font_size +
                                                        "px",
                                                    color: this.state.vote_font,
                                                    background:
                                                        this.state.vote_btn,
                                                }}
                                                onMouseOver={this.toggleHovertwo(
                                                    votes_button_font_color_hover,
                                                    votes_button_bgcolor_hover,
                                                    "vote_btn",
                                                    butn_msg
                                                )}
                                                onMouseLeave={this.toggleleavetwo(
                                                    votes_button_font_color,
                                                    votes_button_bgcolor,
                                                    "vote_btn",
                                                    butn_msg
                                                )}
                                                onClick={() =>
                                                    this.handlelogin()
                                                }
                                            >
                                                <FavoriteIcon />
                                            </IconButton>,
                                            this.props,
                                            butn_msg,
                                            this.state.HASH,
                                            this.handlelogin
                                        )}
                                </div>
                            )
                        }

                        {(onlylogged == 0 || check_logged == true) &&
                            time_to_vote == null &&
                            typeof allcontest == "undefined" &&
                            wp.hooks.applyFilters(
                                "wpvc_buyvotes_btn",
                                <Button
                                    variant="contained"
                                    className={
                                        single_page != null &&
                                        time_to_vote == null
                                            ? "wpvc_voting_btns wpvc_next_vote_btn"
                                            : "wpvc_voting_btns"
                                    }
                                    color="primary"
                                    startIcon={<FavoriteIcon />}
                                    style={{
                                        fontSize: votes_button_font_size + "px",
                                        color: this.state.vote_font,
                                        background: this.state.vote_btn,
                                    }}
                                    onMouseOver={this.toggleHovertwo(
                                        votes_button_font_color_hover,
                                        votes_button_bgcolor_hover,
                                        "vote_btn",
                                        butn_msg
                                    )}
                                    onMouseLeave={this.toggleleavetwo(
                                        votes_button_font_color,
                                        votes_button_bgcolor,
                                        "vote_btn",
                                        butn_msg
                                    )}
                                    disabled={
                                        this.state.vote_btn_loading == 1
                                            ? true
                                            : false
                                    }
                                    onClick={() =>
                                        this.handlevote(
                                            this.props.singlepost.id,
                                            term_id,
                                            this.props.settings.contest,
                                            post_index,
                                            null,
                                            butn_msg
                                        )
                                    }
                                >
                                    {this.state.vote_btn_loading === 0 && (
                                        <React.Fragment>
                                            {butn_msg == true &&
                                                t("fr_vote_now")}
                                            {butn_msg == "voterestricted" &&
                                                t("voterestricted")}
                                            {butn_msg == false &&
                                                t("voterestricted")}
                                            {butn_msg == "voted" && t("voted")}
                                            {butn_msg == "voteagain" &&
                                                t("voteagain")}
                                        </React.Fragment>
                                    )}
                                    {this.state.vote_btn_loading === 1 && (
                                        <React.Fragment>
                                            {t("Processing")}
                                            <CircularProgress
                                                className="wpvc_vote_btn_loading"
                                                color="secondary"
                                                size={16}
                                            />
                                        </React.Fragment>
                                    )}
                                </Button>,
                                this.props,
                                butn_msg,
                                this.state.HASH
                            )}

                        {onlylogged == 1 &&
                            check_logged == false &&
                            time_to_vote == null &&
                            typeof allcontest == "undefined" &&
                            wp.hooks.applyFilters(
                                "wpvc_buyvotes_btn",
                                <Button
                                    variant="contained"
                                    className={
                                        single_page != null &&
                                        time_to_vote == null
                                            ? "wpvc_voting_btns wpvc_next_vote_btn"
                                            : "wpvc_voting_btns"
                                    }
                                    color="primary"
                                    startIcon={<FavoriteIcon />}
                                    style={{
                                        fontSize: votes_button_font_size + "px",
                                        color: this.state.vote_font,
                                        background: this.state.vote_btn,
                                    }}
                                    onMouseOver={this.toggleHovertwo(
                                        votes_button_font_color_hover,
                                        votes_button_bgcolor_hover,
                                        "vote_btn",
                                        butn_msg
                                    )}
                                    onMouseLeave={this.toggleleavetwo(
                                        votes_button_font_color,
                                        votes_button_bgcolor,
                                        "vote_btn",
                                        butn_msg
                                    )}
                                    onClick={() => this.handlelogin()}
                                >
                                    {this.state.vote_btn_loading === 0 && (
                                        <React.Fragment>
                                            {butn_msg == true &&
                                                t("fr_vote_now")}
                                            {butn_msg == "voterestricted" &&
                                                t("voterestricted")}
                                            {butn_msg == false &&
                                                t("voterestricted")}
                                            {butn_msg == "voted" && t("voted")}
                                            {butn_msg == "voteagain" &&
                                                t("voteagain")}
                                        </React.Fragment>
                                    )}
                                    {this.state.vote_btn_loading === 1 && (
                                        <React.Fragment>
                                            {t("Processing")}
                                            <CircularProgress
                                                className="wpvc_vote_btn_loading"
                                                color="secondary"
                                                size={16}
                                            />
                                        </React.Fragment>
                                    )}
                                </Button>,
                                this.props,
                                butn_msg,
                                this.state.HASH,
                                this.handlelogin
                            )}

                        {single_page != null && time_to_vote == null && (
                            <Link
                                className="wpvc_single_prev_button"
                                style={{
                                    color: votes_button_font_color,
                                    background: votes_button_bgcolor,
                                    opacity: posts.next_link != null ? 1 : 0.6,
                                }}
                                href={
                                    posts.next_link != null
                                        ? posts.next_link
                                        : undefined
                                }
                                title={
                                    posts.next_title != null
                                        ? posts.next_title
                                        : ""
                                }
                            >
                                <NavigateNextIcon className="wpvc_prev_post" />
                            </Link>
                        )}
                    </Grid2>
                    <EmailGrab
                        {...allprops}
                        showlog={this.state.show_emailgrab}
                        handleSaveVotes={this.handleSaveVotes}
                        handclose={this.email_handleClose}
                        email_address={this.state.email_address}
                        recaptcha={this.state.recaptcha}
                        handleVoterDetails={this.handleVoterDetails}
                        handleValueChange={this.handleEmailValueChange}
                        handleCaptchaChange={this.handleCaptchaValueChange}
                        voter_state={this.state}
                    />

                    <VoterDetailsPopup
                        {...allprops}
                        showlog={this.state.show_voterdetails}
                        handleSaveVotes={this.handleSaveVotes}
                        handclose={this.email_handleClose}
                        email_address={this.state.email_address}
                        recaptcha={this.state.recaptcha}
                        handleVoterDetails={this.handleVoterDetails}
                        handleValueChange={this.handleEmailValueChange}
                        handleCaptchaChange={this.handleCaptchaValueChange}
                        voter_state={this.state}
                    />

                    <EmailVerify
                        {...allprops}
                        showlog={this.state.show_emailverify}
                        email_code={this.state.email_code}
                        show_verifycode={this.state.show_verifycode}
                        disabled={this.state.disabled}
                        handleSaveVotes={this.handleSaveVotes}
                        handclose={this.email_handleClose}
                        email_address={this.state.email_address}
                        handleVoterDetails={this.handleVoterDetails}
                        handleValueChange={this.handleEmailValueChange}
                        handleEmailverify={this.handleEmailverify}
                        voter_state={this.state}
                    />

                    <Loginpopup
                        {...allprops}
                        showlog={this.state.show_login}
                        handclose={this.handleClose}
                        handlog={this.handlelogin}
                    />
                    {this.state.show_not_vote == 1 && (
                        <Dialog
                            maxWidth="xs"
                            fullWidth={true}
                            onClose={this.handlemodalclose}
                            aria-labelledby="customized-dialog-title"
                            open={this.state.show_not_vote == 1 ? true : false}
                        >
                            <MuiDialogTitle
                                component="div"
                                className="wpvc_restriction_popup_title"
                                onClose={this.handlemodalclose}
                            >
                                <Typography variant="h6">
                                    {t("restricted")}
                                </Typography>
                                <IconButton
                                    aria-label="close"
                                    onClick={this.handlemodalclose}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </MuiDialogTitle>

                            <MuiDialogContent
                                dividers
                                className="wpvc_restriction_popup_content"
                            >
                                <Typography>
                                    <WarningIcon />
                                    {
                                        allprops.settings.contest
                                            .vote_tobestarteddesc
                                    }
                                </Typography>
                            </MuiDialogContent>
                            <MuiDialogActions className="wpvc_restriction_popup_actions">
                                <Grid2
                                    container
                                    size={12}
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Typography>
                                        {t("share_with_friends")}
                                    </Typography>
                                </Grid2>
                                <Grid2
                                    container
                                    size={12}
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <ContestantSocial
                                        {...allprops}
                                        singlepost={this.props.singlepost}
                                        view="grid"
                                    />
                                </Grid2>
                            </MuiDialogActions>
                        </Dialog>
                    )}

                    {this.state.show_popup == 1 &&
                        this.state.show_index == post_index && (
                            <Dialog
                                maxWidth="sm"
                                fullWidth={true}
                                onClose={this.handlemodalclose}
                                aria-labelledby="customized-dialog-title"
                                open={this.state.show_popup == 1 ? true : false}
                            >
                                {this.state.showhtml ? (
                                    <div>
                                        <MuiDialogTitle
                                            component="div"
                                            className="wpvc_sucess_popup_title"
                                            onClose={this.handlemodalclose}
                                        >
                                            <Typography variant="h6">
                                                {t(this.state.popup_title)}
                                            </Typography>
                                            <IconButton
                                                aria-label="close"
                                                onClick={this.handlemodalclose}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </MuiDialogTitle>
                                        <div
                                            style={{
                                                padding: "10px",
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: this.state
                                                    .popup_content,
                                            }}
                                        ></div>
                                    </div>
                                ) : (
                                    <div>
                                        <MuiDialogTitle
                                            component="div"
                                            className="wpvc_sucess_popup_title"
                                            onClose={this.handlemodalclose}
                                        >
                                            <Typography variant="h6">
                                                {t(this.state.popup_title)}
                                            </Typography>
                                            <IconButton
                                                aria-label="close"
                                                onClick={this.handlemodalclose}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </MuiDialogTitle>
                                        <MuiDialogContent
                                            dividers
                                            className="wpvc_sucess_popup_content"
                                            style={{
                                                background:
                                                    this.state.popbg_color,
                                            }}
                                        >
                                            <Typography>
                                                {this.state.popbg_icon ==
                                                    "sucess" && <CheckIcon />}
                                                {this.state.popbg_icon ==
                                                    "already" && (
                                                    <WarningIcon />
                                                )}
                                                {t(this.state.popup_content)}
                                            </Typography>
                                        </MuiDialogContent>
                                        <MuiDialogActions className="wpvc_restriction_popup_actions">
                                            <Grid2
                                                container
                                                size={12}
                                                direction="row"
                                                justifyContent="center"
                                                alignItems="center"
                                            >
                                                {(facebook == "on" ||
                                                    threads == "on" ||
                                                    twitter == "on" ||
                                                    pinterest == "on" ||
                                                    reddit == "on" ||
                                                    linkedin == "on" ||
                                                    tumblr == "on") && (
                                                    <Typography>
                                                        {t(
                                                            "share_with_friends"
                                                        )}
                                                    </Typography>
                                                )}
                                            </Grid2>
                                            <Grid2
                                                container
                                                size={12}
                                                direction="row"
                                                justifyContent="center"
                                                alignItems="center"
                                            >
                                                <ContestantSocial
                                                    {...allprops}
                                                    singlepost={
                                                        this.props.singlepost
                                                    }
                                                    view="grid"
                                                />
                                            </Grid2>
                                        </MuiDialogActions>
                                    </div>
                                )}
                            </Dialog>
                        )}
                    {this.state.show_recaptcha == 1 && (
                        <Dialog
                            maxWidth="xs"
                            fullWidth={true}
                            onClose={this.handleCaptchaClose}
                            aria-labelledby="customized-dialog-title"
                            open={this.state.show_recaptcha == 1 ? true : false}
                        >
                            <MuiDialogTitle
                                component="div"
                                className="wpvc_sucess_popup_title"
                                onClose={this.handleCaptchaClose}
                            >
                                <Typography variant="h6">
                                    {t("captcha_title")}
                                </Typography>
                                <IconButton
                                    aria-label="close"
                                    onClick={this.handleCaptchaClose}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </MuiDialogTitle>

                            <MuiDialogContent
                                dividers
                                className="wpvc_captcha_popup_content"
                                style={{
                                    background:
                                        this.props.settings.color
                                            .votes_button_bgcolor_hover,
                                }}
                            >
                                <ReCAPTCHA
                                    sitekey={vote_recapatcha_key}
                                    onChange={this.onCaptchaClick}
                                />
                            </MuiDialogContent>
                        </Dialog>
                    )}
                    {(vote_tracking_method == "cookie_traced" ||
                        vote_tracking_method == "ip_traced" ||
                        vote_tracking_method == "user_traced") && (
                        <CancelButton
                            {...this.props}
                            // votebtnstates={this.state}
                            handlevote={this.handlevote}
                            vote_btn_msg={butn_msg}
                        />
                    )}
                    {this.state.show_vote_count == 1 ? (
                        <Dialog
                            maxWidth="sm"
                            fullWidth={true}
                            onClose={this.handlevotesmodalclose}
                            aria-labelledby="customized-dialog-title"
                            open={true}
                        >
                            <MuiDialogTitle
                                component="div"
                                className="wpvc_sucess_popup_title"
                                onClose={this.handlevotesmodalclose}
                            >
                                <Typography variant="h6">
                                    {t("Enter number of votes")}
                                </Typography>
                                <IconButton
                                    aria-label="close"
                                    onClick={this.handlevotesmodalclose}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </MuiDialogTitle>
                            <MuiDialogContent
                                dividers
                                className="wpvc_captcha_popup_content"
                            >
                                <Grid2 container className="wpvc_form_grid">
                                    <Grid2
                                        className="wpvc_label"
                                        style={{ padding: "20px" }}
                                        size={4}
                                    >
                                        <Typography variant="button">
                                            {t("buyvotes_category_votes")}
                                        </Typography>
                                    </Grid2>
                                    <Grid2 size={8}>
                                        <FormControl
                                            className="wpvc_form_control"
                                            fullWidth
                                        >
                                            <TextField
                                                name="no_of_votes"
                                                type="number"
                                                value={this.state.no_of_votes}
                                                fullWidth
                                                onChange={(e) =>
                                                    this.handleVoteCount(e)
                                                }
                                                slotProps={{
                                                    input: {
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {t("votes")}
                                                            </InputAdornment>
                                                        ),
                                                    },
                                                    htmlInput: {
                                                        step: 1,
                                                        min: 1,
                                                        max: this.props
                                                            .buy_votes_count,
                                                        pattern: "[0-9]*",
                                                        inputMode: "numeric",
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    </Grid2>
                                    <Grid2 size={4}></Grid2>
                                    <Grid2 className="wpvc_label" size={8}>
                                        <Typography variant="body2">
                                            {t("remaining_buy_votes")}{" "}
                                            {this.props.buy_votes_count}
                                        </Typography>
                                    </Grid2>
                                </Grid2>
                            </MuiDialogContent>
                            <MuiDialogActions className="wpvc_restriction_popup_actions">
                                <Grid2 container justifyContent="flex-start">
                                    <Button
                                        variant="contained"
                                        className="wpvc_login_btns"
                                        color="secondary"
                                        onClick={() =>
                                            this.handlevote(
                                                this.props.singlepost.id,
                                                term_id,
                                                this.props.settings.contest,
                                                post_index,
                                                null,
                                                butn_msg
                                            )
                                        }
                                    >
                                        {t("fr_vote_now")}
                                    </Button>
                                </Grid2>
                            </MuiDialogActions>
                        </Dialog>
                    ) : null}
                </React.Fragment>
            );
        } else {
            return (
                <Backdrop className="wpvc_back_loader" open={true}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            );
        }
    }
}

const settingstate = (state) => {
    return { post: state.wpvcfrontdata };
};

export default connect(settingstate, {
    frontsingleimmute,
    frontimmutable,
    Savevotes,
    SendEmailVerify,
    verifyCaptcha,
    Cancel_votes,
})(withTranslation("translations")(VoteButton));
